module.exports = __webpack_public_path__ + "static/pintando-fb79468e3cf735da79e704b4e2a6db14.svg";